import { create } from "zustand";
import { applyTheme } from '@/utils/theme';

interface ThemeState {
    dark: boolean;
    setDark: (dark: boolean) => void;
    toggleDark: () => void;
}

const useThemeStore = create<ThemeState>((set, get) => ({
    dark: false,

    setDark: (dark) => {
        applyTheme(dark);
        set({ dark });
    },

    toggleDark: () => {
        get().setDark(!get().dark);
    },
}));

export default useThemeStore;
